import { FC, useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { References } from "../References/References";
import { HeaderNavigationProps } from "./HeaderNavigation.types";
import { ReactComponent as TickIcon } from "images/TickIcon.svg";
import { ReactComponent as WarnIcon } from "images/infoIcon.svg";
import styles from "./HeaderNavigation.module.sass";
import { useOutsideAlerter } from "hooks/useOutsideAlerter";
import cn from "classnames";
import { DocumentsMenu } from "components/DocumentsMenu/DocumentsMenu";
import DropSelect from "components-new/DropSelect";
import { getOrganizations } from "../../toolkit/organizations/organizations.thunks";
import Tooltip from "../../components-new/Tooltip";
import { useAppDispatch, useAppSelector } from "../../toolkit/hooks";
import { snackWrapper } from "../../helpers";
import { ClearOrganizations } from "../../toolkit/organizations/organizations.slice";

export const HeaderNavigation: FC<HeaderNavigationProps> = ({ authed }) => {
	const location = useLocation();
	const navigate = useNavigate();

	const dispatch = useAppDispatch();

	const [shown, setShown] = useState({
		isReferences: false,
		isDocuments: false,
	});

	const isIncompleteReferences = useAppSelector((state) => state.references.isIncompleteReferences);

	const ref = useRef<any>();
	const documentsRef = useRef<any>();

	useOutsideAlerter(ref.current, () => setShown((prev) => ({ ...prev, isReferences: false })));

	useEffect(() => {}, []);
	const redirect = () => {
		if (location.pathname === "/categorization/organizations") return;
		dispatch(ClearOrganizations());
		dispatch(getOrganizations({ part: 1, quantity: 50, isCategorization: true, archiveMode: false })).then(
			({ payload }: any) => {
				if (payload && payload.length) {
					navigate("/categorization/organizations");
				} else {
					snackWrapper("error", "Нет организаций для категорирования");
				}
				dispatch(ClearOrganizations());
			},
		);
	};

	return (
		<nav className={styles.navigation}>
			<ul className={`${styles.list} ${!authed ? styles.disabled : ""}`}>
				<li className={cn(styles.item, "df")} ref={ref}>
					{isIncompleteReferences && (
						<Tooltip
							menu={
								<div className={styles.tooltip}>
									Есть незаполненные справочники, необходимые для корректной работы системы
								</div>
							}
							position="left"
							color="themeWhite">
							<WarnIcon className={styles.warnIcon} />
						</Tooltip>
					)}

					<button
						onClick={() => setShown((prev) => ({ ...prev, isReferences: !prev.isReferences }))}
						className={cn(styles["menu-btn"], styles[`menu-btn-${shown.isReferences}`])}>
						<span className={styles.txt}>Справочники</span>
						<TickIcon className={styles["menu-btn-icon"]} />
					</button>
					<div className={styles.referencesWrp}>
						{shown.isReferences && <References close={(prev: any) => setShown({ ...prev, isReferences: false })} />}
					</div>
				</li>
				<li className={styles.item} onClick={redirect}>
					<span
						className={`${styles.txt}  ${
							location.pathname.includes("categorization/organizations") ||
							location.pathname.includes("categorization/newModel")
								? styles.activated
								: ""
						}`}>
						Категорирование
					</span>
				</li>
				<li className={styles.item} ref={documentsRef}>
					<button
						onClick={() => setShown((prev) => ({ ...prev, isDocuments: !prev.isDocuments }))}
						className={cn(styles["menu-btn"], styles[`menu-btn-${shown.isDocuments}`])}>
						<span className={styles.txt}>Документы</span>
						<div>
							<TickIcon className={styles["menu-btn-icon"]} />
						</div>
					</button>
					{shown.isDocuments && (
						<DropSelect
							outsideClick={() => setShown((prev) => ({ ...prev, isDocuments: false }))}
							position={"center"}
							zIndex={15}
							target={documentsRef.current}>
							<DocumentsMenu close={(prev: any) => setShown({ ...prev, isDocuments: false })} />
						</DropSelect>
					)}
				</li>
				<li className={styles.item}>
					<Link
						to={"/history"}
						className={`${styles.txt}  ${location.pathname.includes("/history") ? styles.activated : ""}`}>
						История действий
					</Link>
				</li>
			</ul>
		</nav>
	);
};
